export class AppConstants {
    public static GOOGLE_CLIENT_ID = '138155935175-mcvi6soulletoaeb9og4ggtr5b96k0lk.apps.googleusercontent.com';
    public static colors = [
        { name: 'Road', color: '#402020' },
        { name: 'Lane Markings', color: '#ff0000' },
        { name: 'Undrivable', color: '#808060' },
        { name: 'Movable', color: '#00ff66' },
        { name: 'My Car', color: '#cc00ff' }
    ];
    public static defaultImage = 'https://raw.githubusercontent.com/commaai/comma10k/master/imgs/0005_836d09212ac1b8fa_2018-06-15--15-57-15_23_345.png';
    public static defaultImageNumber = '0005';
    public static imageDirectory = 'https://raw.githubusercontent.com/commaai/comma10k/master/imgs/';
    public static imageDirectoryName = 'imgs';
    public static maskDirectoryName = 'masks';
    public static mandatoryFieldMsg = 'Please enter the all mandatory fields.';
    public static defaultErrorMessage = 'Something went wrong, Please try again.';
    public static noDataFound = 'Failed to get the records.';
}

export const DEVICE_TYPE_LIST = [
    { name: "Switches", value: "Switches" },
    { name: "Router", value: "Router" },
    { name: "Access Points", value: "Access points" },
    { name: "Client Bridges", value: "Client Bridges" },
    { name: "NAS", value: "NAS" },
    { name: "Cloud NAS", value: "Cloud NAS" },
    { name: "Odroid", value: "Odroid" },
]

export const OUTPUT_TYPE_LIST = [
    { name: "BOSCH", value: "BOSCH" },
    { name: "AXIS_HORN", value: "AXIS_HORN" },
    { name: "IP_POWER_BOX", value: "IP_POWER_BOX" },
    { name: "X310", value: "X310" },
    // { name: "X310New", value: "X310New" },
    { name: "X410", value: "X410" },
    { name: "AXIS_D4100_E", value: "AXIS_D4100_E" },
    { name: "Audio", value: "Audio" },
    { name: "IPPB ", value: "IPPB " },
]

export const STROBE_TYPE_LIST = [
    { name: "Strobe", value: "Strobe" }
]

export const CAPTURE_RESOLUTIONS = [
    {
        "name": "176x120",
        "value": "R_176_BY_120",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" }
        ]
    },
    {
        "name": "320x180",
        "value": "R_320_BY_180",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" }
        ]
    },
    {
        "name": "320x240",
        "value": "R_320_BY_240",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240", }
        ]
    },
    {
        "name": "240x320",
        "value": "R_240_BY_320",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" }
        ]
    },
    {
        "name": "352x240",
        "value": "R_352_BY_240",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
        ]
    },
    {
        "name": "352x288",
        "value": "R_352_BY_288",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
        ]
    },
    {
        "name": "270x480",
        "value": "R_270_BY_480",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
        ]
    },
    {
        "name": "480x270",
        "value": "R_480_BY_270",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
        ]
    },
    {
        "name": "480x360",
        "value": "R_480_BY_360",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
        ]
    },
    {
        "name": "512x224",
        "value": "R_512_BY_224",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
        ]
    },
    {
        "name": "480x480",
        "value": "R_480_BY_480",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
        ]
    },
    {
        "name": "640x240",
        "value": "R_640_BY_240",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
        ]
    },
    {
        "name": "640x288",
        "value": "R_640_BY_288",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
        ]
    },
    {
        "name": "640x360",
        "value": "R_640_BY_360",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
        ]
    },
    {
        "name": "640x480",
        "value": "R_640_BY_480",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
        ]
    },
    {
        "name": "704x240",
        "value": "R_704_BY_240",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
        ]
    },
    {
        "name": "704x480",
        "value": "R_704_BY_480",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
        ]
    },
    {
        "name": "704x576",
        "value": "R_704_BY_576",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
        ]
    },
    {
        "name": "720x480",
        "value": "R_720_BY_480",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
        ]
    },
    {
        "name": "768x432",
        "value": "R_768_BY_432",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
        ]
    },
    {
        "name": "800x450",
        "value": "R_800_BY_450",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
        ]
    },
    {
        "name": "800x600",
        "value": "R_800_BY_600",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
            { "name": "800x600", "value": "R_800_BY_600" },
        ]
    },
    {
        "name": "1280x720",
        "value": "R_1280_BY_720",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
            { "name": "800x600", "value": "R_800_BY_600" },
            { "name": "1280x720", "value": "R_1280_BY_720" },
        ]
    },
    {
        "name": "1920x1080",
        "value": "R_1920_BY_1080",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
            { "name": "800x600", "value": "R_800_BY_600" },
            { "name": "1280x720", "value": "R_1280_BY_720" },
            { "name": "1920x1080", "value": "R_1920_BY_1080" },
        ]
    },
    {
        "name": "1024x208",
        "value": "R_1024_BY_208",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
            { "name": "800x600", "value": "R_800_BY_600" },
            { "name": "1280x720", "value": "R_1280_BY_720" },
            { "name": "1920x1080", "value": "R_1920_BY_1080" },
            { "name": "1024x208", "value": "R_1024_BY_208" },
        ]
    },
    {
        "name": "1024x452",
        "value": "R_1024_BY_452",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
            { "name": "800x600", "value": "R_800_BY_600" },
            { "name": "1280x720", "value": "R_1280_BY_720" },
            { "name": "1920x1080", "value": "R_1920_BY_1080" },
            { "name": "1024x208", "value": "R_1024_BY_208" },
            { "name": "1024x452", "value": "R_1024_BY_452" },
        ]
    },
    {
        "name": "960x272",
        "value": "R_960_BY_272",
        "windowSize": [
            { "name": "176x120", "value": "R_176_BY_120" },
            { "name": "320x180", "value": "R_320_BY_180" },
            { "name": "320x240", "value": "R_320_BY_240" },
            { "name": "240x320", "value": "R_240_BY_320" },
            { "name": "352x240", "value": "R_352_BY_240" },
            { "name": "352x288", "value": "R_352_BY_288" },
            { "name": "270x480", "value": "R_270_BY_480" },
            { "name": "480x270", "value": "R_480_BY_270" },
            { "name": "480x360", "value": "R_480_BY_360" },
            { "name": "512x224", "value": "R_512_BY_224" },
            { "name": "480x480", "value": "R_480_BY_480" },
            { "name": "640x240", "value": "R_640_BY_240" },
            { "name": "640x288", "value": "R_640_BY_288" },
            { "name": "640x360", "value": "R_640_BY_360" },
            { "name": "640x480", "value": "R_640_BY_480" },
            { "name": "704x240", "value": "R_704_BY_240" },
            { "name": "704x480", "value": "R_704_BY_480" },
            { "name": "704x576", "value": "R_704_BY_576" },
            { "name": "720x480", "value": "R_720_BY_480" },
            { "name": "768x432", "value": "R_768_BY_432" },
            { "name": "800x450", "value": "R_800_BY_450" },
            { "name": "960x272", "value": "R_960_BY_272" },
            { "name": "800x600", "value": "R_800_BY_600" },
            { "name": "1280x720", "value": "R_1280_BY_720" },
            { "name": "1920x1080", "value": "R_1920_BY_1080" },
            { "name": "1024x208", "value": "R_1024_BY_208" },
            { "name": "1024x452", "value": "R_1024_BY_452" },
        ]
    },
];

export const TYPE = [
    { name: "ANALOG", value: "ANALOG" },
    { name: "ACTI", value: "ACTI" },
    { name: "AXIS", value: "AXIS" },
    { name: "AXIS_P", value: "AXIS_P" },
    { name: "BOSCH", value: "BOSCH" },
    { name: "CANON", value: "CANON" },
    { name: "MOBOTIX", value: "MOBOTIX" },
    { name: "ARECONT", value: "ARECONT" },
    { name: "AVHS", value: "AVHS" },
    { name: "PANASONIC", value: "PANASONIC" },
    { name: "IVIS", value: "IVIS" },
    { name: "IVIGIL", value: "IVIGIL" },
    { name: "IVIS_IP", value: "IVIS_IP" },
    { name: "DAHUA", value: "DAHUA" },
    { name: "DAHUA_IP", value: "DAHUA_IP" },
    { name: "SUMSUNG", value: "SUMSUNG" },
    { name: "RTSP", value: "RTSP" },
    { name: "PI", value: "PI" },
    { name: "PROXY", value: "PROXY" },
    { name: "PROXY_KERNEL", value: "PROXY_KERNEL" },
    { name: "HONEYWELL", value: "HONEYWELL" },
    { name: "SPECO", value: "SPECO" },
    { name: "RTSP_OVER_HTTP", value: "RTSP_OVER_HTTP" },
    { name: "RTSP_OVER_TCP", value: "RTSP_OVER_TCP" },
    { name: "AXIS_M7014", value: "AXIS_M7014" },
]

export const FORMAT = [
    { name: "H264", value: "H264" },
    { name: "MPEG4", value: "MPEG4" },
    { name: "MJPEG", value: "MJPEG" },
    { name: "H265", value: "H265" },
]

export const MOTION_DETUCTION__METHODS = [
    { name: "Detect All", value: "DETECT_ALL" },
    { name: "Filter Noise", value: "FILTER_NOISE" },
    { name: "SOM", value: "SOM" },
    { name: "Vu Meter", value: "VU_METER" },
];

export const MOTION_DETUCTION_SENSITIVITY_DETECTALL = [
    { val_name: "Very High", val: "VERY_HIGH" },
    { val_name: "High", val: "HEIGH" },
    { val_name: "Medium", val: "MEDIUM" },
    { val_name: "Low", val: "LOW" },
]

export const MOTION_DETUCTION_SENSITIVITY_FILTERNOISE = [
    { val_name: "Level 1", val: "LEVEL_1" },
    { val_name: "Level 2", val: "LEVEL_2" },
    { val_name: "Level 3", val: "LEVEL_3" },
    { val_name: "Level 4", val: "LEVEL_4" },
]

export const ANALYTIC_NAME = [
    { name: "VMD4", value: "VMD4" },
    { name: "FENCEGUARD", value: "FENCEGUARD" },
    { name: "MOTIONGUARD", value: "MOTIONGUARD" },
]

export const hasPrivilege = (privilege) => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    let hasAccess = false;
    if (currentUser) {
        if (currentUser['privileges'] && currentUser['privileges'].length > 0) {
            for (let i = 0; i < currentUser['privileges'].length; i++) {
                if (currentUser['privileges'][i].toLowerCase() === privilege) {
                    hasAccess = true;
                }
            }
        }
    }
    return hasAccess;
}

export const ErrorMessageFormField = {
    cameraName: "Please enter the Camera Name.",
    analyticName: "Please select Analytic Name.",
    camType: " Please select Type.",
    camIpUrl: "Please enter the IP / URL.",
    username: "Please enter the Username.",
    password: "Please enter the Password.",
    format: "Please select Format.",
    camUniqueId: "Please enter the Camera Unique ID.",
    comPortNo: "Please enter the COM Port No.",
    feedDelay: "Please enter the Feed Delay (SEC).",
    supportPtz: "Please select Supports PTZ.",
    email: "Please enter the Email ID.",
    active: "Please select Active.",
    methods: "Please select Method.",
    sensitivity: "Please select Sensitivity.",
    capture: "Please select Capture.",
    winSizeView: "Please select Window Size View.",
    macAddress: "Please enter the MAC Address.",
    hdUrl: "Please enter the HD URL.",
    monitoringType: "Please select Monitoring type.",
    sdUrl: "Please enter the SD URL.",
    ec2Id: "Please enter ID.",
    ec2NodeName: "Please enter Node Name.",
    ec2InstanceId: "Please enter Instance Id.",
    ec2PrivateId: "Please enter Private IP.",
    ec2PublicId: "Please enter Public IP.",
    deviceType: "Please select the device type.",
    ipAddress: "Please enter the IP Address.",
    secondaryIpAddress: "Please enter the secondary IP Address.",
    deviceName: "Please enter the device name.",
    portNumber: "Please enter the port number.",
    potentialId: "Please enter the potential ID.",
    type:"Please select the Type.",
    displayName:"Please enter the display name.",
    comportNo:"Please select the comport no.",
    strobeName:"Please enter the strobe name.",
    strobeId:"Please enter the strobe ID.",
    siteName:"Please enter the site name.",
    farmType:"Please select the farm type.",
    name: "Please enter name",
    userName: "Please enter User name.",
    user_password: "Please enter password.",
    confirmpassword: "Please enter confirm password",
    passwordStrength: "Password should contain minimum 8 characters with atleast 1 small,1 capital, 1 special character and 1 number.",
    passwordMatch: "Passwords do not match",
    emailId: "Please enter Email-ID.",
    phone: "Please enter Phone No.",
    phoneLength: "Please enter valid Phone number",
    pattern: "Please enter valid Phone number",
    userType:"Please select any User Type.",
    userRole: "Please select any Role",
    addSiteName: "Please select atleast 1 site",

}

export const CAMERA_OWNED_LIST = [
    { name: "Select", value: "" },
    { name: "Pro-Vigil", value: "Pro-Vigil" },
    { name: "Take Over", value: "Take Over" },
]

export const LPR_CAMERA_LIST = [
    { name: "Yes", value: true },
    { name: "No", value: false},
]

export const FARM_TYPE_LIST = [
    { name: "Default", value: "default" },
    { name: "Whitelisted", value: "whitelisted"},
]